import { CALL_API } from './../../middlewares/api';
import { initMessaging } from '../../base';

const onSaveConfiguracoesAfterRequest = (value) => ({
  [CALL_API]: {
    type: 'SAVE_NOTIFICATIONS',
    endpoint: 'notificacoes',
    authenticated: true,
    config: {
      method: 'PUT',
      querystring: { type: 'configuracoes' },
      body: {
        value
      }
    },
    success: () => {
      alert("Notificações salvas com sucesso.");
    }
  },
  value
});

const onSaveConfiguracoes = (value) => dispatch => {
  if (value.some(v => 2 === v[1])) {  // Contains PUSH notifications
    initMessaging.request().then(v => {
      if (v) {
        dispatch(onSaveConfiguracoesAfterRequest(value));
      } else {
        alert("Você precisa dar permissão para receber notificações.");
      }
    });
  } else {
    dispatch(onSaveConfiguracoesAfterRequest(value));
  }
};

const onLoadConfiguracoes = () => ({
  [CALL_API]: {
    type: 'LIST_CONFIGURACOES',
    endpoint: 'notificacoes',
    authenticated: true,
    config: {
      method: 'GET',
      querystring: { type: 'configuracoes' }
    }
  },
});

const onLoadNotificacoes = () => ({
  [CALL_API]: {
    type: 'LIST_NOTIFICACOES',
    endpoint: 'notificacoes',
    authenticated: true,
    config: {
      method: 'GET',
      querystring: { type: 'notificacoes' }
    }
  },
});

const closeNotification = value => ({
  [CALL_API]: {
    type: 'CLOSE_NOTIFICACAO',
    endpoint: 'notificacoes',
    authenticated: true,
    config: {
      method: 'PUT',
      querystring: { type: 'notificacoes', close: 'single', id: value.id }
    }
  },
  value
});

const closeAllNotifications = () => ({
  [CALL_API]: {
    type: 'CLOSE_ALL_NOTIFICACAO',
    endpoint: 'notificacoes',
    authenticated: true,
    config: {
      method: 'PUT',
      querystring: { type: 'notificacoes', close: 'all' }
    }
  }
});


export default {
  onSaveConfiguracoes,
  onLoadConfiguracoes,
  onLoadNotificacoes,
  closeNotification,
  closeAllNotifications
};


// WEBPACK FOOTER //
// ./src/modules/notificacao/actions.js